import React from "react";

import { QuestionCircleTwoTone, CheckCircleTwoTone } from "@ant-design/icons";

import { VENDOR_STATUS_CONFIRMED, TASK_STATUS, TASK_STATUS_FOR_VENDORS } from "../../../../config/const";

import { Table, Space, Button, Divider } from "antd";

import DateTimeTask from "../../../../components/job/task/status/datetime";

const Tasks = (props) => {
    const columns = () => [
        { title: "#", dataIndex: "code", key: "order", width: 50 },
        { title: "Service", dataIndex: "name", key: "name" },
        {
            title: "Category",
            dataIndex: "category",
            key: "category",
            render: (category, record) => {
                return <>{category?.name}</>;
            },
        },
        {
            title: "Language(s)",
            dataIndex: "language_type",
            key: "languageType",
            render: (type, record) => {
                if (type == "Single") {
                    if (record.language_family == "LTR" || record.language_family == "RTL") {
                        return <>{record.language_family}</>;
                    }
                    return <>{record.language?.name}</>;
                } else {
                    return <>{record.language_pair?.name}</>;
                }
            },
        },
        {
            title: "Unit",
            dataIndex: "base_unit",
            key: "unit",
            render: (unit, record) => {
                if (unit) {
                    if (record.is_word) {
                        return <>{record.effective_word_count} WC</>;
                    } else {
                        return (
                            <>
                                {record.base_unit_amount} {unit?.name}
                            </>
                        );
                    }
                }
            },
        },
        {
            title: "Vendor",
            dataIndex: "vendor",
            key: "vendor",
            render: (vendor, record) => {
                return (
                    <Space split={<Divider type="vertical" />}>
                        {record.vendor_status === VENDOR_STATUS_CONFIRMED ? (
                            <CheckCircleTwoTone twoToneColor="#52c41a" />
                        ) : (
                            <QuestionCircleTwoTone />
                        )}
                        <Button size="small" type="dashed">
                            {vendor ? vendor.name : "(Unassigned)"}
                        </Button>
                    </Space>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (value, record) => {
                return (
                    <Button size="small" type="dashed">
                        {value}
                    </Button>
                );
            },
        },
        {
            title: "Deadline",
            dataIndex: "deadline_at",
            key: "deadlineAt",
            render: (deadlineAt, record) => <DateTimeTask value={deadlineAt} status={record.status} />,
        },

        {
            title: "Free",
            dataIndex: "isFree",
            key: "isFree",
            width: 50,
            render: (free) => (free ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <></>),
        },
    ];

    return (
        <>
            <Table
                rowKey={(row) => row.id}
                size="small"
                className="components-table-demo-nested"
                columns={columns()}
                dataSource={props.tasks}
                pagination={false}
            />
        </>
    );
};

export default Tasks;
